import script from "./dynamicTemplate.vue?vue&type=script&lang=ts"
export * from "./dynamicTemplate.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__